import React, { useEffect, useState, useContext } from 'react';
import './Achievement2.css';
import { achievementData } from '../../data/achievementData';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { LanguageContext } from '../../contexts/LanguageContext';

function Achievement2() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const achievements = achievementData.achievements;
  const totalAchievements = achievements.length;
  
  // Récupérer la langue actuelle
  const { language } = useContext(LanguageContext);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalAchievements);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalAchievements) % totalAchievements);
  };

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    
    const sections = document.querySelectorAll('.achievement-section');
    sections.forEach((section) => {
      gsap.fromTo(section, { opacity: 0,scale:0.8 }, {
        opacity: 1,
        scale: 1,
        duration: 2,
        scrollTrigger: {
          trigger: section,
          start: 'top center',
          end: 'bottom center',
          toggleActions: 'play none none reverse',
        },
      });
    });
  }
  , []);
  return (
    <div className="achievement-section" id="achievements">
      <div>
        <h3 className="achievement-title">
          {language === 'en' ? 'Certificates' : 'Certificats'}
        </h3>
      </div>
      <div className="image-container">
        <button className="nav-arrow left-arrow" onClick={handlePrev}>
          <FaArrowLeft />
        </button>
        <div className="images-wrapper">
          {achievements.map((achievement, index) => {
            let position = 'next';
            if (index === currentIndex) position = 'active';
            else if (index === (currentIndex - 1 + totalAchievements) % totalAchievements) position = 'prev';

            return (
              <img 
                key={achievement.id} 
                src={achievement.image} 
                alt={achievement.title[language]} 
                className={`slide ${position}`} 
              />
            );
          })}
        </div>
        <button className="nav-arrow right-arrow" onClick={handleNext}>
          <FaArrowRight />
        </button>
      </div>

      <div className="achievement-details">
        <h3>{achievements[currentIndex].title[language]}</h3> {/* Titre dynamique */}
        <p>{achievements[currentIndex].details[language]}</p> {/* Détails dynamiques */}
        <p>{achievements[currentIndex].date}</p>
        <p>{achievements[currentIndex].field[language]}</p> {/* Domaine dynamique */}
      </div>
    </div>
  );
}

export default Achievement2;
